module.exports = __webpack_public_path__ + "img/pin-upd.850316a0.svg";